const React = require("react");
/*const auth = require("../../Authenticator.js");*/
const server = require("../../Server.js");


function getHRFile(url) {
    return function () {
        server.Get(url).then((res) => {
            res.blob().then((blob) => {
                var url = window.URL.createObjectURL(blob);
                var a = window.document.createElement('a');
                a.href = url;
                a.download = "HRFile.csv";
                a.click();
            });
        });
    };
}

const HRContactAssignmentsForm = React.createClass({
    render() {
        return (<div>
            HR Contact store assignments file:&nbsp;
            <a href="javascript:void(0)" target="_blank" onClick={getHRFile(this.props.SampleFileURL)}>Click here to download</a>
        </div>);
    }
});

module.exports = HRContactAssignmentsForm;


// WEBPACK FOOTER //
// ./src/components/metadata/HRContactAssignmentsForm.jsx